if (!customElements.get('ae-hrs')) {
  customElements.define('ae-hrs', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-hrs-interest]');
        if (!trigger) return;
        const select = this.querySelector('#HRSInterest');
        if (!select) return;
        const option = Array.from(select.options).find(item => item.value === trigger.dataset.hrsInterest);
        if (option) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  });
}



